import api from './api';

/**
 * Service para operações relacionadas a adolescentes.
 */
const adolescenteService = {
  /**
   * Busca adolescentes por nome (autocomplete).
   * @param {string} search - Termo de busca
   * @param {number} limit - Limite de resultados (padrão: 10)
   * @returns {Promise<Array>} Lista de adolescentes {id, nome_adolescente}
   */
  async autocomplete(search, limit = 10) {
    try {
      const response = await api.get('/adolescentes/autocomplete', {
        params: { search, limit }
      });
      return response.data?.data || [];
    } catch (error) {
      console.error('Erro ao buscar adolescentes (autocomplete):', error);
      throw error;
    }
  },

  /**
   * Lista todos os adolescentes (paginado).
   * @returns {Promise<Object>} Resposta paginada
   */
  async list() {
    try {
      const response = await api.get('/adolescentes');
      return response.data;
    } catch (error) {
      console.error('Erro ao listar adolescentes:', error);
      throw error;
    }
  },

  /**
   * Busca um adolescente por ID.
   * @param {number} id - ID do adolescente
   * @returns {Promise<Object>} Dados do adolescente
   */
  async getById(id) {
    try {
      const response = await api.get(`/adolescentes/${id}`);
      return response.data?.data;
    } catch (error) {
      console.error(`Erro ao buscar adolescente ${id}:`, error);
      throw error;
    }
  },

  /**
   * Cria um novo adolescente.
   * @param {Object} data - Dados do adolescente
   * @returns {Promise<Object>} Adolescente criado
   */
  async create(data) {
    try {
      const response = await api.post('/adolescentes', data);
      return response.data?.data;
    } catch (error) {
      console.error('Erro ao criar adolescente:', error);
      throw error;
    }
  },

  /**
   * Atualiza um adolescente existente.
   * @param {number} id - ID do adolescente
   * @param {Object} data - Dados a atualizar
   * @returns {Promise<Object>} Adolescente atualizado
   */
  async update(id, data) {
    try {
      const response = await api.put(`/adolescentes/${id}`, data);
      return response.data?.data;
    } catch (error) {
      console.error(`Erro ao atualizar adolescente ${id}:`, error);
      throw error;
    }
  },

  /**
   * Deleta um adolescente.
   * @param {number} id - ID do adolescente
   * @returns {Promise<void>}
   */
  async delete(id) {
    try {
      await api.delete(`/adolescentes/${id}`);
    } catch (error) {
      console.error(`Erro ao deletar adolescente ${id}:`, error);
      throw error;
    }
  }
};

export default adolescenteService;
